import React from 'react'
import {
  MobileActionCard,
  MobileDateRangeSearchCard,
  MobileTabbedReportLayout
} from '../../../components/mobile'
import { getUserTabConfig } from '../helpers/userReportTabs'
import UserReportDownloadComponent from '../components/UserReportDownloadComponent'
import ReportEffectivenessMobileDateRangeSearch from './ReportEffectivenessMobileDateRangeSearch'

export default function ShowUserViewMobileLayout({
  activeTab,
  setActiveTab,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  today,
  searchFromDates,
  hasError,
  isFetching,
  downloadProps,
  currentPaginationPage,
  totalPaginationPages,
  showPagination,
  paginationDisabled = false,
  onPaginationPageChange,
  handlePaginationClick,
  children
}) {
  return (
    <MobileTabbedReportLayout
      contentPaddingX={0}
      tabs={getUserTabConfig()}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      hasError={hasError}
      isFetching={isFetching}
      currentPage={currentPaginationPage}
      totalPages={totalPaginationPages}
      showPagination={showPagination}
      paginationDisabled={paginationDisabled}
      onPaginationPageChange={onPaginationPageChange}
      handlePaginationClick={handlePaginationClick}
      filterContent={
        <MobileDateRangeSearchCard>
          <ReportEffectivenessMobileDateRangeSearch
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            maxDateStr={today}
            onSearch={searchFromDates}
          />
        </MobileDateRangeSearchCard>
      }
      actionContent={
        <MobileActionCard>
          <UserReportDownloadComponent {...downloadProps} />
        </MobileActionCard>
      }
    >
      {children}
    </MobileTabbedReportLayout>
  )
}
